export default {
  // Words
  account: 'Account',
  add: 'Add',
  dashboard: 'Profile',
  home: '@:branding.appTagline',
  profile: 'Profile',
  transports: 'Transports',
  stocks: 'Inentory stock',
  transports: 'Transports'
}
